import React, { useState } from 'react';
import { useDevicesEld } from '../../../../../Hooks/TT_ELD/Team/Devices';
import SearchInput from '../../../../../Utils/SearchInput';
import { Button, Col, Drawer, Grid, Select } from 'antd';
import SearchOptions from '../../../../../Utils/SearchOptions';
import { SearchResultForCompany, SearchResultForDevices } from '../../../../../Utils/SearchResults';
import useRouteQuery from '../../../../../Utils/useRouterQuery';
import { useTagQuerySync } from '../../../../../Utils/useTagQuerySync';
import { FilterOutlined } from '@ant-design/icons';
import DevicesEldTable from './DevicesEldTable/DevicesEldTable';
// import DevicesEldTable from './DevicesEldTable/DevicesEldTable';

const roleList = [
  {
    label: 'IOS',
    value: 'IOS',
  },

  {
    label: 'Android ',
    value: 'Android',
  },
];

const optionEldType = [
  {
    label: 'ProTRUX',
    value: 'protrux',
  },
  {
    label: 'PT',
    value: 'pt',
  },
  {
    label: 'IOSiX',
    value: 'iosix',
  },
];

const { useBreakpoint } = Grid;

const DevicesEld = () => {
  const [skip, setSkip] = useState<number>(1);
  const [sortedInfo, setSortedInfo] = useState<any>({});
  const [userId, setUserId] = useState<string | number>('');
  const [userName, setUserName] = useRouteQuery('', 'userName', (v) => String(v));
  const [model, setModel] = useRouteQuery('', 'model', (v) => String(v));
  const [eldVersion, setEldVersion] = useRouteQuery('', 'eldVersion', (v) => String(v));
  const [appVersion, setAppVersion] = useRouteQuery('', 'appVersion', (v) => String(v));
  const [versionCode, setVersionCode] = useRouteQuery('', 'versionCode', (v) => String(v));
  const [device, setDevice] = useRouteQuery('', 'device', (v) => String(v));
  const [eldType, setEldType] = useRouteQuery('', 'eldType', (v) => String(v));
  const [sort, setSort] = useRouteQuery('', 'sort', (v) => String(v));
  const [companyId, setCompanyId] = useState<string | number>('');
  const [companyName, setCompanyName] = useRouteQuery('', 'companyName', String);

  const [filterOpen, setFilterOpen] = useState(false);

  const openDrawer = () => setFilterOpen(true);
  const closeDrawer = () => setFilterOpen(false);

  const { Option } = Select;

  const screens = useBreakpoint();
  const isMobile = !screens.md;

  useTagQuerySync(
    { en_US: 'Devices ELD', zh_CN: '' },
    'devices-eld',
    {
      sortedInfo,
      userId,
      userName,
      model,
      eldVersion,
      appVersion,
      versionCode,
      device,
      sort,
      skip,
      companyName,
      companyId,
    },
    {
      sortedInfo: setSortedInfo,
      userId: setUserId,
      userName: setUserName,
      model: setModel,
      eldVersion: setEldVersion,
      appVersion: setAppVersion,
      versionCode: setVersionCode,
      device: setDevice,
      sort: setSort,
      skip: setSkip,
      companyName: setCompanyName,
      companyId: setCompanyId,
    },
  );

  const { data, isLoading, refetch } = useDevicesEld(
    userId,
    model,
    eldVersion,
    appVersion,
    versionCode,
    device,
    eldType,
    sort,
    // id ? id : 1,
    skip,
    companyId,
  );
  const onChange = (query: any) => {
    setSkip(query.current);
  };

  const handleChange = (event: string, inputName: string) => {
    const updateFunctions: Record<string, (value: string) => void> = {
      model: setModel,
      eldVersion: setEldVersion,
      appVersion: setAppVersion,
      versionCode: setVersionCode,
      companyName: setCompanyName,
    };

    if (updateFunctions[inputName]) {
      updateFunctions[inputName](event.trim());
      setSkip(1);
    }
  };

  const handleSearchSelect =
    (setter: (val: string | number) => void, nameSetter?: (val: string) => void) =>
    (val: any, { valId }: { valId: string }) => {
      setter(valId);
      nameSetter?.(val);
      if (valId) setSkip(1);
    };

  const handleSearchSelectComp =
    (setter: any, nameSetter?: any) =>
    (val: any, { valId }: { valId: string }) => {
      setter(valId);
      nameSetter?.(val);
      setSkip(1);
    };

  return (
    <div>
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: !isMobile ? 'space-between' : 'flex-end',
          gap: 5,
        }}
      >
        {!isMobile && (
          <>
            <SearchOptions
              value={companyName}
              SearchResult={SearchResultForCompany}
              onSelect={handleSearchSelectComp(setCompanyId, setCompanyName)}
              placeholder="Search by Company"
              title="Search by company"
            />
            <SearchOptions
              SearchResult={SearchResultForDevices}
              onSelect={handleSearchSelect(setUserId, setUserName)}
              placeholder="Search by driver"
              value={userName}
              title="Search by driver"
            />
            <SearchInput
              value={model}
              placeholder="Search by model"
              onDebounceChange={(event: string) => handleChange(event, 'model')}
              title="Search by model"
            />
            <SearchInput
              value={eldVersion}
              placeholder="Search by ELD version"
              onDebounceChange={(event: string) => handleChange(event, 'eldVersion')}
              title="Search by ELD version"
            />
            <SearchInput
              value={appVersion}
              placeholder="Search by app version"
              onDebounceChange={(event: string) => handleChange(event, 'appVersion')}
              title="Search by app version"
            />
            <SearchInput
              value={versionCode}
              placeholder="Search by version code"
              onDebounceChange={(event: string) => handleChange(event, 'versionCode')}
              title="Search by version code"
            />
            <Select
              value={device ? device : 'all'}
              defaultValue="all"
              onChange={(value, option) => {
                setDevice(value === 'all' ? '' : value);
                setSkip(1);
              }}
              style={{ width: 200 }}
            >
              <Option key={'all'}>All Device</Option>
              {roleList.map((u: any, index: any) => (
                <Option key={index} value={u.value}>
                  {u.label}
                </Option>
              ))}
            </Select>
            <Select
              value={sort ? sort : 'Is Active'}
              defaultValue="Is Active"
              onChange={(value, option) => {
                setSort(value === 'Is Active' ? '' : value);
                setSkip(1);
              }}
              style={{ width: 200 }}
            >
              <Option key={''} value="">
                Is Active
              </Option>
              <Option value="true">True</Option>
              <Option value="false">False</Option>
            </Select>
            <Select
              value={eldType ? eldType : 'all'}
              defaultValue="all"
              onChange={(value, option) => {
                setEldType(value === 'all' ? '' : value);
                setSkip(1);
              }}
              style={{ width: 200 }}
            >
              <Option key={'all'}>All ELD Type</Option>
              {optionEldType.map((u: any, index: any) => (
                <Option key={index} value={u.value}>
                  {u.label}
                </Option>
              ))}
            </Select>
          </>
        )}

        {isMobile && (
          <Col>
            <Button size="large" icon={<FilterOutlined />} onClick={openDrawer} />
          </Col>
        )}

        <Button style={{ marginLeft: 'auto' }} size={'large'} onClick={() => refetch()}>
          Refresh
        </Button>
      </span>

      <Drawer
        title="Filters"
        placement="bottom"
        width="30%"
        onClose={closeDrawer}
        open={filterOpen}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: 8,
            gap: 8,
          }}
        >
          <SearchOptions
            value={companyName}
            SearchResult={SearchResultForCompany}
            onSelect={handleSearchSelectComp(setCompanyId, setCompanyName)}
            placeholder="Search by Company"
            title="Search by company"
          />
          <SearchOptions
            SearchResult={SearchResultForDevices}
            onSelect={handleSearchSelect(setUserId, setUserName)}
            placeholder="Search by driver"
            value={userName}
            title="Search by driver"
          />
          <SearchInput
            value={model}
            placeholder="Search by model"
            onDebounceChange={(event: string) => handleChange(event, 'model')}
            title="Search by model"
          />
          <SearchInput
            value={eldVersion}
            placeholder="Search by ELD version"
            onDebounceChange={(event: string) => handleChange(event, 'eldVersion')}
            title="Search by ELD version"
          />
          <SearchInput
            value={appVersion}
            placeholder="Search by app version"
            onDebounceChange={(event: string) => handleChange(event, 'appVersion')}
            title="Search by app version"
          />
          <SearchInput
            value={versionCode}
            placeholder="Search by version code"
            onDebounceChange={(event: string) => handleChange(event, 'versionCode')}
            title="Search by version code"
          />
          <Select
            value={device ? device : 'all'}
            defaultValue="all"
            onChange={(value, option) => {
              setDevice(value === 'all' ? '' : value);
              setSkip(1);
            }}
            style={{ width: 200 }}
          >
            <Option key={'all'}>All Device</Option>
            {roleList.map((u: any, index: any) => (
              <Option key={index} value={u.value}>
                {u.label}
              </Option>
            ))}
          </Select>
          <Select
            value={sort ? sort : 'Is Active'}
            defaultValue="Is Active"
            onChange={(value, option) => {
              setSort(value === 'Is Active' ? '' : value);
              setSkip(1);
            }}
            style={{ width: 200 }}
          >
            <Option key={''} value="">
              Is Active
            </Option>
            <Option value="true">True</Option>
            <Option value="false">False</Option>
          </Select>
          <Select
            value={eldType ? eldType : 'all'}
            defaultValue="all"
            onChange={(value, option) => {
              setEldType(value === 'all' ? '' : value);
              setSkip(1);
            }}
            style={{ width: 200 }}
          >
            <Option key={'all'}>All ELD Type</Option>
            {optionEldType.map((u: any, index: any) => (
              <Option key={index} value={u.value}>
                {u.label}
              </Option>
            ))}
          </Select>
        </div>
      </Drawer>
      <DevicesEldTable
        data={data?.data}
        onChange={onChange}
        total={data?.count}
        isLoading={isLoading}
        setSortedInfo={setSortedInfo}
        sortedInfo={sortedInfo}
        setSort={setSort}
        sort={sort}
        setSkip={setSkip}
        skip={skip}
      />
    </div>
  );
};

export default DevicesEld;
